"use strict";

exports.__esModule = true;
exports.POST_LIST_SETTINGS_PARAMS = exports.POST_LIST_WIDGET_DEFAULTS = void 0;

var _layoutTypes = require("./layout-types");

var POST_LIST_WIDGET_DEFAULTS = {
  margins: 10,
  sidesPadding: 16,
  postSize: 254,
  contentHeight: 156,
  imageRatio: 2,
  spacing: 12,
  layoutName: _layoutTypes.LAYOUT_NAME_PG_GRID,
  layoutType: _layoutTypes.LAYOUT_PG_GRID
};
exports.POST_LIST_WIDGET_DEFAULTS = POST_LIST_WIDGET_DEFAULTS;
var POST_LIST_SETTINGS_PARAMS = {
  isFeatured: {
    wixParam: 'postListWidgetIsFeatured',
    appSettingsPath: 'style.booleans.postListWidgetIsFeatured',
    "default": false
  },
  entityCount: {
    wixParam: 'postListWidgetEntityCount',
    appSettingsPath: 'style.numbers.postListWidgetEntityCount',
    "default": 3,
    minValue: 1,
    maxValue: 60
  }
};
exports.POST_LIST_SETTINGS_PARAMS = POST_LIST_SETTINGS_PARAMS;